import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { beforeItems, afterItems } from '../../data/content';
export function BeforeAfter() {
  return <Section data-id="element-75" data-mp="26mmfkwfyznpj">
      <Eyebrow data-id="element-76" data-mp="26k044lpyko21">The difference</Eyebrow>
      <Heading data-id="element-77" data-mp="22lkbo2b3ynh8">Stop second-guessing yourself every time you turn on your welder</Heading>

      <div className="mt-9 grid gap-5 md:grid-cols-2" data-id="element-78" data-mp="2zbjtknd5eych">
        <div className="rounded-2xl border border-ink-600 bg-ink-800 p-5" data-id="element-79" data-mp="2z8xmeou66kus">
          <div className="flex items-center gap-2" data-id="element-80" data-mp="2ucgnr0pcgo3g">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-ember/20" data-id="element-81" data-mp="2qa3kciy2l29u">
              <XIcon className="h-5 w-5 text-ember" aria-hidden="true" data-id="element-82" data-mp="2lbisp7wvvqx0" />
            </span>
            <h3 className="font-display text-2xl font-extrabold uppercase tracking-wide text-zinc-300" data-id="element-83" data-mp="1ev6td3ibs2zu">
              Before…
            </h3>
          </div>
          <ul className="mt-4 space-y-3" data-id="element-84" data-mp="19uis7p0du5rw">
            {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-85" data-mp="176nqw527dpb8">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden="true" data-id="element-86" data-mp="1c4gtko4as16r" />
                <span className="text-[15px] leading-snug text-zinc-400" data-id="element-87" data-mp="1c22zoilcsv0s">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-2xl border border-flame-500/50 bg-flame-500/[0.07] p-5" data-id="element-88" data-mp="132psjwkpcij8">
          <div className="flex items-center gap-2" data-id="element-89" data-mp="oemhw9vpsio3">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-flame-500/20" data-id="element-90" data-mp="od1papsyn9sv">
              <CheckIcon className="h-5 w-5 text-flame-400" aria-hidden="true" data-id="element-91" data-mp="t7fq57qe694x" />
            </span>
            <h3 className="font-display text-2xl font-extrabold uppercase leading-tight tracking-wide text-white" data-id="element-92" data-mp="fcd9bpk0azdc">
              With Weld Decision System™
            </h3>
          </div>
          <ul className="mt-4 space-y-3" data-id="element-93" data-mp="5i3hqa2w253o">
            {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-94" data-mp="aek2qvesk3cj">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flame-400" aria-hidden="true" data-id="element-95" data-mp="2c4srk1lxdlwe" />
                <span className="text-[15px] leading-snug text-zinc-100" data-id="element-96" data-mp="27d0zfmn4f845">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-8 rounded-2xl border border-ink-600 bg-ink-800 px-5 py-6 text-center" data-id="element-97" data-mp="239uuqjfnpozs">
        <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-zinc-500" data-id="element-98" data-mp="1yep7nhaiq4a4">
          The goal is simple
        </p>
        <p className="mt-3 font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-99" data-mp="2r1jqk9rosvlh">
          See the problem. <span className="text-flame-500" data-id="element-100" data-mp="2m1dwkmxy2x08">Make the decision.</span> Take the next
          step.
        </p>
      </div>

      <div className="mt-8" data-id="element-101" data-mp="2h2u92i3pdd5r">
        <CTAButton data-id="element-102" data-mp="2h5q6847q7xt5" />
      </div>
    </Section>;
}